import api from '@/lib/api'

const state = {
    complianceTypes: [],
    acceptanceTypes: [],
    instrumentTypes: [],
    instrumentStatusTypes: [],
    instrumentLocationTypes: [],
    instrumentFunctionTypes: [],
    instrumentFeatureTypes: [],
    availabilityTypes: [],
    lidarFunctionTypes: [],
    lidarFeatureTypes: [],
    lidarChannelTypes: [],
    sccLidarConfigurationTypes: [],
    qaEvaluationTypes: [],
    lidarConfigurationIssueTypes: []
}

const getters = {
    complianceTypes(state) {
        return state.complianceTypes
    },
    acceptanceTypes(state) {
        return state.acceptanceTypes
    },
    instrumentTypes(state) {
        return state.instrumentTypes
    },
    instrumentStatusTypes(state) {
        return state.instrumentStatusTypes
    },
    instrumentLocationTypes(state) {
        return state.instrumentLocationTypes
    },
    instrumentFunctionTypes(state) {
        return state.instrumentFunctionTypes
    },
    instrumentFeatureTypes(state) {
        return state.instrumentFeatureTypes
    },
    availabilityTypes(state) {
        return state.availabilityTypes
    },
    lidarFunctionTypes(state) {
        return state.lidarFunctionTypes
    },
    lidarFeatureTypes(state) {
        return state.lidarFeatureTypes
    },
    lidarChannelTypes(state) {
        return state.lidarChannelTypes
    },
    sccLidarConfigurationTypes(state) {
        return state.sccLidarConfigurationTypes
    },
    qaEvaluationTypes(state) {
        return state.qaEvaluationTypes
    },
    lidarConfigurationIssueTypes(state) {
        return state.lidarConfigurationIssueTypes
    }
}

const actions = {
    async getComplianceTypes({dispatch}) {
        return await dispatch(
            'getTypesList',
            {
                apiCall: api.facilities.getCARSComplianceTypes,
                getter: 'cars/complianceTypes',
                mutation: 'cars/SET_COMPLIANCE_TYPES'
            }, {root: true}
        )
    },
    async getAcceptanceTypes({dispatch}) {
        return await dispatch(
            'getTypesList',
            {
                apiCall: api.facilities.getCARSAcceptanceTypes,
                getter: 'cars/acceptanceTypes',
                mutation: 'cars/SET_ACCEPTANCE_TYPES'
            }, {root: true}
        )
    },
    async getInstrumentTypes({dispatch}) {
        return await dispatch(
            'getTypesList',
            {
                apiCall: api.instrument.getInstrumentTypes,
                getter: 'cars/instrumentTypes',
                mutation: 'cars/SET_INSTRUMENT_TYPES'
            }, {root: true}
        )
    },
    async getInstrumentStatusTypes({dispatch}) {
        return await dispatch(
            'getTypesList',
            {
                apiCall: api.instrument.getInstrumentStatusTypes,
                getter: 'cars/instrumentStatusTypes',
                mutation: 'cars/SET_INSTRUMENT_STATUS_TYPES'
            }, {root: true}
        )
    },
    async getInstrumentLocationTypes({dispatch}) {
        return await dispatch(
            'getTypesList',
            {
                apiCall: api.instrument.getInstrumentLocationTypes,
                getter: 'cars/instrumentLocationTypes',
                mutation: 'cars/SET_INSTRUMENT_LOCATION_TYPES'
            }, {root: true}
        )
    },
    async getInstrumentFunctionTypes({dispatch}) {
        return await dispatch(
            'getTypesList',
            {
                apiCall: api.instrument.getInstrumentFunctionTypes,
                getter: 'cars/instrumentFunctionTypes',
                mutation: 'cars/SET_INSTRUMENT_FUNCTION_TYPES'
            }, {root: true}
        )
    },
    async getInstrumentFeatureTypes({dispatch}) {
        return await dispatch(
            'getTypesList',
            {
                apiCall: api.instrument.getInstrumentFeatureTypes,
                getter: 'cars/instrumentFeatureTypes',
                mutation: 'cars/SET_INSTRUMENT_FEATURE_TYPES'
            }, {root: true}
        )
    },
    async getLidarFunctionTypes({dispatch}) {
        return await dispatch(
            'getTypesList',
            {
                apiCall: api.instrument.getLidarFunctionTypes,
                getter: 'cars/lidarFunctionTypes',
                mutation: 'cars/SET_LIDAR_FUNCTION_TYPES'
            }, {root: true}
        )
    },
    async getLidarFeatureTypes({dispatch}) {
        return await dispatch(
            'getTypesList',
            {
                apiCall: api.instrument.getLidarFeatureTypes,
                getter: 'cars/lidarFeatureTypes',
                mutation: 'cars/SET_LIDAR_FEATURE_TYPES'
            }, {root: true}
        )
    },
    async getLidarChannelTypes({dispatch}) {
        return await dispatch(
            'getTypesList',
            {
                apiCall: api.instrument.getLidarChannelTypes,
                getter: 'cars/lidarChannelTypes',
                mutation: 'cars/SET_LIDAR_CHANNEL_TYPES'
            }, {root: true}
        )
    },
    async getAvailabilityTypes({dispatch}) {
        return await dispatch(
            'getTypesList',
            {
                apiCall: api.instrument.getAvailabilityTypes,
                getter: 'cars/availabilityTypes',
                mutation: 'cars/SET_AVAILABILITY_TYPES'
            }, {root: true}
        )
    },
    async getSccLidarConfigurationTypes({dispatch}) {
        return await dispatch(
            'getTypesList',
            {
                apiCall: api.scc.getLidarConfigurationTypes,
                getter: 'cars/sccLidarConfigurationTypes',
                mutation: 'cars/SET_SCC_LIDAR_CONFIGURATION_TYPES'
            }, {root: true}
        )
    },
    async getQaEvaluationTypes({dispatch}) {
        return await dispatch(
            'getTypesList',
            {
                apiCall: api.qa.getEvaluationTypes,
                getter: 'cars/qaEvaluationTypes',
                mutation: 'cars/SET_QA_EVALUATION_TYPES'
            }, {root: true}
        )
    },
    async getLidarConfigurationIssueTypes({dispatch}) {
        return await dispatch(
            'getTypesList',
            {
                apiCall: api.qa.getLidarConfigurationIssueTypes,
                getter: 'cars/lidarConfigurationIssueTypes',
                mutation: 'cars/SET_LIDAR_CONFIGURATION_ISSUE_TYPES'
            }, {root: true}
        )
    }
}

// mutations
const mutations = {
    SET_COMPLIANCE_TYPES(state, payload) {
        state.complianceTypes = payload
    },
    SET_ACCEPTANCE_TYPES(state, payload) {
        state.acceptanceTypes = payload
    },
    SET_INSTRUMENT_TYPES(state, payload) {
        state.instrumentTypes = payload
    },
    SET_INSTRUMENT_STATUS_TYPES(state, payload) {
        state.instrumentStatusTypes = payload
    },
    SET_INSTRUMENT_LOCATION_TYPES(state, payload) {
        state.instrumentLocationTypes = payload
    },
    SET_INSTRUMENT_FUNCTION_TYPES(state, payload) {
        state.instrumentFunctionTypes = payload
    },
    SET_INSTRUMENT_FEATURE_TYPES(state, payload) {
        state.instrumentFeatureTypes = payload
    },
    SET_LIDAR_FUNCTION_TYPES(state, payload) {
        state.lidarFunctionTypes = payload
    },
    SET_LIDAR_FEATURE_TYPES(state, payload) {
        state.lidarFeatureTypes = payload
    },
    SET_LIDAR_CHANNEL_TYPES(state, payload) {
        state.lidarChannelTypes = payload
    },
    SET_AVAILABILITY_TYPES(state, payload) {
        state.availabilityTypes = payload
    },
    SET_SCC_LIDAR_CONFIGURATION_TYPES(state, payload) {
        state.sccLidarConfigurationTypes = payload
    },
    SET_QA_EVALUATION_TYPES(state, payload) {
        state.qaEvaluationTypes = payload
    },
    SET_LIDAR_CONFIGURATION_ISSUE_TYPES(state, payload) {
        state.lidarConfigurationIssueTypes = payload
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}